module.exports = __webpack_public_path__ + "img/greeting-observatory.02fbf307.svg";